module.exports = __webpack_public_path__ + "static/img/格物智安工地安全管理平台操作说明-8.9b11747.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/格物智安工地安全管理平台操作说明-8.jpg
// module id = ZHkR
// module chunks = 0